import { MinzeElement } from 'minze'

export interface LvcCheckOrangeIcon {}

export class LvcCheckOrangeIcon extends MinzeElement {
  html = () => `
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 5.5C13.9121 8.53265 10.8438 11.9123 7.93448 15.139C7.75324 15.34 7.44472 15.3602 7.23892 15.1844C5.59461 13.7798 4.39733 12.7079 3 10.939" stroke="#FF4600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
